<script setup lang="ts">
import EventCheckpointAutocomplete from '@/components/Filters/components/EventCheckpointAutocomplete.vue'
import { GridLayout } from '@/components/Layouts'
import { useGridSize } from '@/hooks/useGridSize'
import type { DetectionFilters } from '@/types/filters/DetectionFilters'
import type { EventCheckpointType } from '@/types/filters/EventCheckpointType'
import type { DetectionModel } from '@/types/models/DetectionModel'
import type { EventModel } from '@/types/models/EventModel'
import StackLayout from '../../components/Layouts/StackLayout.vue'
import type { CheckpointModel } from '../../types/models/CheckpointModel'

type Props = {
    filters: DetectionFilters
    selectedEvent?: Partial<EventModel>
    selectedCheckpoint?: Partial<CheckpointModel>
    gridSizeProps?: number
}
const props = defineProps<Props>()

type Emits = {
    (e: 'change', value: Partial<DetectionModel>): void
    (e: 'selectEvent', value?: EventModel): void
    (e: 'selectCheckpoint', value?: CheckpointModel): void
}
const emit = defineEmits<Emits>()

const gridSize = useGridSize()

const handleChange = (value: EventCheckpointType) => {
    if (
        (props.filters.site_id ?? undefined) === (value.site_id ?? undefined) &&
        (props.filters.poi_id ?? undefined) === (value.poi_id ?? undefined) &&
        (props.filters.device_id ?? undefined) === (value.device_id ?? undefined)
    )
        return
    emit('change', value)
}

const handleSelectEvent = (event?: EventModel) => emit('selectEvent', event)
const handleSelectCheckpoint = (checkpoint?: CheckpointModel) =>
    emit('selectCheckpoint', checkpoint)
</script>

<template>
    <StackLayout direction="column" :gap="8">
        <GridLayout
            :maxItemPerRow="gridSizeProps ?? gridSize"
            :gap="8"
            :rowGap="12"
            class="full-width flex-wrap"
            isResponsive>
            <EventCheckpointAutocomplete
                :event="selectedEvent"
                :checkpoint="selectedCheckpoint"
                :site_id="filters.site_id"
                :poi_id="filters.poi_id"
                keepEventInStorage
                filterAllEvents
                @change="handleChange($event)"
                @selectEvent="handleSelectEvent"
                @selectCheckpoint="handleSelectCheckpoint" />

            <slot name="rowFilters" />
        </GridLayout>
        <slot />
    </StackLayout>
</template>
